import NineBoxes from "./NineBoxes";
import Admin from "./admin/Admin";
import FormalEducationMetrics from "./admin/FormalEducationMetrics";
import Matrix from "./admin/Matrix";
import MetricJobExperience from "./admin/MetricJobExperience";
import MetricNineBoxes from "./admin/MetricNineBoxes";

// import PlanCarreraIndividual from "./PlanCarreraIndividual";
const NueveCajasRouter = [
  {
    type: "private",
    path: "/matriz-nueve-cajas/admin",
    roles: ["administrador", "Responsable_Carrera_Sucesion"],
    component: Admin,
    exact: true,
  },
  {
    type: "private",
    path: "/matriz-nueve-cajas/nueve-cajas",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Carrera_Sucesion",
      "alta_direccion",
    ],
    component: NineBoxes,
    exact: true,
  },    
  {
    type: "private",
    path: "/matriz-nueve-cajas/matriz",
    roles: ["administrador", "Responsable_Carrera_Sucesion"],
    component: Matrix,
    exact: true,
  },
  {
    type: "private", 
    path: "/matriz-nueve-cajas/educacion-formal-metricas",
    roles: ["administrador", "Responsable_Carrera_Sucesion"],
    component: FormalEducationMetrics,
    exact: true,
  },
  {
    type: "private",
    path: "/matriz-nueve-cajas/metrica-nueve-cajas",
    roles: ["administrador", "Responsable_Carrera_Sucesion"],
    component: MetricNineBoxes,
    exact: true,
  },
  {
    type: "private",
    path: "/matriz-nueve-cajas/metrica-experiencia-en-puesto",
    roles: ["administrador", "Responsable_Carrera_Sucesion"],
    component: MetricJobExperience,
    exact: true,
  },


];

export default NueveCajasRouter;
